import React from "react";

const Logo = (props) => {
  return (
    <img
      src="/images/tokenate.png"
      alt="Logo"
      {...props}
      style={{ width: "auto", maxWidth: "180px", marginRight: "80px" }}
    />
  );
};

export default Logo;
